import React from 'react';
import { FadeIn, SectionTitle, Card } from '../components/UI';

export default function CookiePolicyPage() {
  return (
    <div style={{ paddingTop: 100, background: 'var(--dark)' }}>
      <section style={{ padding: '60px 40px 100px', maxWidth: 1000, margin: '0 auto' }}>
        <FadeIn>
          <SectionTitle subtitle="Legal" title="Cookie Policy" />
        </FadeIn>

        <div style={{ display: 'flex', flexDirection: 'column', gap: 18 }}>
          <Card>
            <p style={{ fontFamily: 'var(--font-body)', color: 'var(--text-secondary)', lineHeight: 1.75 }}>
              Effective date: 26 February 2026.
            </p>
            <p style={{ fontFamily: 'var(--font-body)', color: 'var(--text-secondary)', lineHeight: 1.75 }}>
              This website uses cookies and similar technologies to keep the site running reliably and to understand
              how the service is used.
            </p>
          </Card>

          <Card>
            <h3 style={{ fontFamily: 'var(--font-body)', color: 'var(--text-primary)', marginTop: 0 }}>Types of cookies</h3>
            <p style={{ fontFamily: 'var(--font-body)', color: 'var(--text-secondary)', lineHeight: 1.75 }}>
              Essential cookies support core website functionality and security. We may also use analytics or
              telemetry-related cookies to help monitor performance and improve user experience.
            </p>
          </Card>

          <Card>
            <h3 style={{ fontFamily: 'var(--font-body)', color: 'var(--text-primary)', marginTop: 0 }}>How to control cookies</h3>
            <p style={{ fontFamily: 'var(--font-body)', color: 'var(--text-secondary)', lineHeight: 1.75 }}>
              You can manage or delete cookies through your browser settings. Disabling some cookies may affect how
              parts of the website function.
            </p>
          </Card>

          <Card>
            <h3 style={{ fontFamily: 'var(--font-body)', color: 'var(--text-primary)', marginTop: 0 }}>Updates</h3>
            <p style={{ fontFamily: 'var(--font-body)', color: 'var(--text-secondary)', lineHeight: 1.75, marginBottom: 0 }}>
              We may update this policy as our services or legal requirements change. The latest version is always
              published on this page.
            </p>
          </Card>
        </div>
      </section>
    </div>
  );
}
